import { render, staticRenderFns } from "./WelcomeVideo.vue?vue&type=template&id=4b756de8"
import script from "./WelcomeVideo.vue?vue&type=script&lang=js"
export * from "./WelcomeVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports